import {AccordionDetails, AccordionSummary, Box, Stack, Typography, useTheme} from '@mui/material';
import React from 'react';
import Icon from 'presentation/icons';
import {useAccountInformation, useMediaQueries} from 'presentation/pages/private/hooks';
import {UserTypeEnum} from 'presentation/constants';
import {StyledAccordion} from './styles';
import {CustomAccordionProps} from './types';

export function Accordion({title, items, ...props}: CustomAccordionProps) {
	const theme = useTheme();
	const {isMobile} = useMediaQueries();
	const {
		beneficiary: {tipoUsuarioC},
	} = useAccountInformation();

	return (
		<StyledAccordion disableGutters {...props}>
			<AccordionSummary
				expandIcon={
					<Icon name="expand-more-filled" color={theme.palette.primary.main} size={20} />
				}
				aria-controls="panel1-content"
				id="panel1-header">
				<Stack
					sx={{
						flexDirection: isMobile ? 'column' : 'row',
						alignItems: isMobile ? 'initial' : 'center',
						gap: 0.5,
					}}>
					<Typography variant="body1" color="text.primary">
						{title}
					</Typography>
				</Stack>
			</AccordionSummary>
			<AccordionDetails
				sx={{p: '20px 0px 16px 16px', display: 'flex', flexDirection: 'column', gap: 1}}>
				{items.map((item, index) => (
					<Stack key={index}>
						{typeof item === 'string' ? (
							<Typography variant="body1" color="text.primary">
								{item}
							</Typography>
						) : (
							<Box>
								<Typography variant="body1" color="text.primary">
									{item.item}
								</Typography>
								<Typography variant="body2" color="text.secondary">
									{tipoUsuarioC !== UserTypeEnum.HOLDER &&
									item.dependentDescription
										? item.dependentDescription
										: item.description}
								</Typography>
							</Box>
						)}
					</Stack>
				))}
			</AccordionDetails>
		</StyledAccordion>
	);
}
